import openStreetMaps from './open-street-maps.png';
import arcgisWorld from './arcgis-world.png';
import arcgisStreet from './arcgis-street.png';

const textures = {
  'open-street-maps': openStreetMaps,
  'arcgis-world': arcgisWorld,
  'arcgis-street': arcgisStreet
};

export default textures;
